import { CSSProperties } from "react";
import PsLogo from "../Assets/Icons/playstation.png";
import XboxLogo from "../Assets/Icons/xbox.png";

const MiniConsoleIcons: React.FC = () => {
  const styles = {
    height: "20px",
    marginRight: "10px",
    filter: "grayscale(100%)",
  } as CSSProperties;

  return (
    <span style={{ display: "flex", flexFlow: "row", rowGap: "5px" }}>
      <img src={PsLogo} height={30} style={styles} />
      <img src={XboxLogo} height={30} style={styles} />
    </span>
  );
};

export { MiniConsoleIcons };
